import React from "react";
import "./Overview.css";
import Navbar from '../../Components/Navbar/Navbar';
import Footer from '../../Components/Footer/Footer';

export default function Overview() {
  return (
    <>
    <Navbar/>
    <div className="overviewpage">
      <div className="header">
        <div className="heading">OVERVIEW OF THE YEAR</div>
      </div>
      
      <div id="timeline">
        <ul id="dates">
          <li>
            <a
              href="#1900"
              onClick={() => {
                document.getElementById("issues").classList.remove("hide");
              }}
            >
              JUL-AUG'21
            </a>
          </li>
          <li>
            <a
              href="#1930"
              onClick={() => {
                document.getElementById("issues").classList.remove("hide");
              }}
            >
              SEPT-OCT'21
            </a>
          </li>
          <li>
            <a
              href="#1944"
              onClick={() => {
                document.getElementById("issues").classList.remove("hide");
              }}
            >
              OCT-NOV'21
            </a>
          </li>
          <li>
            <a
              href="#1950"
              onClick={() => {
                document.getElementById("issues").classList.remove("hide");
              }}
            >
              DEC'21
            </a>
          </li>
          <li>
            <a
              href="#1971"
              onClick={() => {
                document.getElementById("issues").classList.remove("hide");
              }}
            >
              JAN-MAR'22
            </a>
          </li>
          <li>
            <a
              href="#1977"
              onClick={() => {
                document.getElementById("issues").classList.remove("hide");
              }}
            >
              FEB-MAR'22
            </a>
          </li>
          <li>
            <a
              href="#1989"
              onClick={() => {
                document.getElementById("issues").classList.remove("hide");
              }}
            >
              APR'22
            </a>
          </li>
          <li>
            <a
              href="#1999"
              onClick={() => {
                document.getElementById("issues").classList.remove("hide");
              }}
            >
              MAY'22
            </a>
          </li>
        </ul>
        <ul id="issues" className="hide">
          <li id="1900" className="selected">
            <h1>Lead Selection and Boarding</h1>
            <span>JUL-AUG'21</span>
            <p>
            Lead Selection was held for selection of a dedicated, passionate team leader who could imply leadership skills and Onboarding was held for making a team with dedicated and passionate members who wish to work with consistency and hardwork.
            </p>
            <button
              onClick={() => {
                document.getElementById("issues").classList.add("hide");
              }}
            >
              Go Back
            </button>
          </li>
          <li id="1930">
            <h1>Cloud Campaign I</h1>
            <span>SEPT-OCT'21</span>
            <p>
            Cloud campaign 1 will be held to give the introduction and use of tools available in cloud programming for beginners to get a kickstart and for professionals to expand their horizons
            </p>
            <button
              onClick={() => {
                document.getElementById("issues").classList.add("hide");
              }}
            >
              Go Back
            </button>
          </li>
          <li id="1944">
            <h1>Android Campaign</h1>
            <span>OCT-NOV'21</span>
            <p>
            Android Campaign will be held to gain hands on practice and expert knowledge on App Dev using Kotlin/Java 
            </p>
            <button
              onClick={() => {
                document.getElementById("issues").classList.add("hide");
              }}
            >
              Go Back
            </button>
          </li>
          <li id="1950">
            <h1>Flutter Campaign</h1>
            <span>DEC'21</span>
            <p>
            The Flutter campaign would help you get enlightenment about your mobile application development skills and to enhance your skills further
            </p>
            <button
              onClick={() => {
                document.getElementById("issues").classList.add("hide");
              }}
            >
              Go Back
            </button>
          </li>
          <li id="1971">
            <h1>Solution Challenge</h1>
            <span>JAN-MAR'22</span>
            <p>
            Solution challenge will be held where we will collectively solve and explain the beginner, intermediate and advance level problems for industry 
            </p>
            <button
              onClick={() => {
                document.getElementById("issues").classList.add("hide");
              }}
            >
              Go Back
            </button>
          </li>
          <li id="1977">
            <h1>Cloud Campaign II</h1>
            <span>FEB-MAR'22</span>
            <p>
            Cloud campaign 2 would give the contributors a window to learn and get hands on experience of using Google Cloud platforms.
            </p>
            <button
              onClick={() => {
                document.getElementById("issues").classList.add("hide");
              }}
            >
              Go Back
            </button>
          </li>
          <li id="1989">
            <h1>Web Campaign</h1>
            <span>APR'22</span>
            <p>
            Web campaign will be held to give knowledge about the frontend and backend part where the introduction of the tech stack like MERN stack will be done through exciting events.
            </p>
            <button
              onClick={() => {
                document.getElementById("issues").classList.add("hide");
              }}
            >
              Go Back
            </button>
          </li>
          <li id="1999">
            <h1>ML Campaign</h1>
            <span>MAY'22</span>
            <p>
            ML Campaign will provide immense knowledge about Machine Learning, Deep Learning and Neural Networks concepts through industry level projects
            </p>
            <button
              onClick={() => {
                document.getElementById("issues").classList.add("hide");
              }}
            >
              Go Back
            </button>
          </li>
        </ul>
      </div>
    </div>
    <Footer/>
    </>
  );
}
